import { createAction, props } from '@ngrx/store';

export const USER_LOGIN_SUCCESS = '[Login] Login Success';
export const USER_ROLE_UPDATED = '[Role User] Role Updated';
// export const USER_LOGIN_FAILURE = '[Login Page] Login Failure';

export const loginSuccess = createAction(
  USER_LOGIN_SUCCESS,
  props<any>()
);

export const roleUpdated = createAction(
  USER_ROLE_UPDATED,
  props<{role: string}>()
);
